import { User } from '@/models/User';
import { UserState, USER_STORE as s } from './types';
import { MutationTree } from 'vuex';


export const mutations: MutationTree<UserState> = {
  [s.SET_LIST_USER](state, utilisateur: Array<User>) {
    state.listUsers = utilisateur;
  },

  [s.SET_STATE_AUTH](state, auth: Boolean) {
    state.authenticated = auth;
  },

  [s.SET_STATE_ERROR](state, err: string) {
    state.errorStatus = err;
  },

  [s.SET_SESSION_LOG](state, sessionlog: Boolean) {
    state.sessionLog = sessionlog;
  },

  [s.SET_CURRENT_USER](state, usercurrent: any) {

    state.currentUser = usercurrent;
  },
  [s.SET_USERS_LOGGED](state, newval: any) {

    state.usersLogged = newval;
  },

  [s.SET_NOM_DOSSIER](state, newval: string) {

    state.nomDossier = newval;
  },
  [s.SET_KEY_DOSSIER](state, newval: string) {

    state.keyDossier = newval;
  },

  [s.SET_ENV_DOSSIER](state, newval: string) {

    state.envDossier = newval;
  },
  [s.SET_ANNONCE](state, newval: string) {
    state.annonce = newval;
  },



};